import mitt from 'mitt';
/**
 * Created by dilip on 2017-01-03.
 */

let eventCounter = 0;
let singleClickTimer;
let emitter = mitt();
function handleDoubleEvents(e, element, singleEventHandler, doubleEventHandler) {
	eventCounter += 1;
	// if there´s no other click in the next 300ms this is going to be a single click
	if (eventCounter === 1) {
		singleClickTimer = setTimeout(() => {
			eventCounter = 0;
			singleEventHandler(element);
		}, 300);

		// otherwise is a double click
	} else if (eventCounter === 2) {
		clearTimeout(singleClickTimer);
		eventCounter = 0;
		doubleEventHandler(element);
	}
}

export { handleDoubleEvents, emitter };



// WEBPACK FOOTER //
// ./mobile-core/src/utils/custom-events.js